<template>
  <div id="order-repay-diff" :class="{ 'fixed': fixed }">
    <div class="container">
      <div class="content">您有一笔￥<span>{{unpayDiff.diff_fee / 100}}</span> 的费用（{{unpayDiff.item}}）待处理！</div>
      <router-link class="el-button el-button--primary el-button--large"
        :to="{name: 'orderDiffPay', params: {oid: orderId}}">立即支付</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderId: Number,
    unpayDiff: Object,
    fixed: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable.less';

#order-repay-diff {
  height: 88px;
  background-color: fade(@main, 90%);
  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 920px;
  }

  .content {
    color: white;
    flex: 1;
    font-size: 16px;

    span {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .el-button {
    background-color: white;
    color: @main;
    border-radius: 50px;
    border: none;
    width: 190px;
    padding: 13px 19px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-repay-diff.vue